import type { CustomBaseDataType } from '../interface';
import type ISiteObjectTypeDto_Api from './SiteObjectTypeDto.api';

/* eslint-disable-next-line @typescript-eslint/no-empty-interface */
export interface ISiteObjectTypeDto_Linkables extends CustomBaseDataType {}

/** 
 * @description all custom properties for
   SiteObjectTypeDto & methods to link against other entities
*/
function linkables(model: Partial<ISiteObjectTypeDto_Api>): ISiteObjectTypeDto_Linkables {
    return {};
}

export default linkables;
